export const SELECTORS = {
    CLOSEST_DETAIL_SECTION: ".shopify-section",
    CONFIGURATOR: "main.pdp .configurator",
    CONFIGURATOR_RENTAL: "main.pdp .configurator.rental",
    PRICE: "section.price .price .amount",
    PRICE_OLD: "section.price .price-old .amount",
    PRICE_STICKY: "section.sticky-cta section.price .price .amount",
    AVAILABILITIES: ".detail-cta .availabilities accordion-item .content",
    SECTION_AVAILABILITIES: ".shopify-section .availabilities accordion-item .content",
    QUANTITY: ".detail-cta x-quantity",
    SECTION_QUANTITY: ".shopify-section x-quantity",
    GALLERY_IMAGES: ".gallery figure",
    CTA: "section.detail-cta .btn.add-to-cart",
    CTA_STICKY: "section.sticky-cta .btn.add-to-cart",
    HIGHLIGHTS: ".pdp-detail > .details",
    SECTION_HIGHLIGHTS: ".shopify-section > .details",
    ATTRIBUTES: ".pdp-about > .tabbed #tab-product-data",
    SECTION_ATTRIBUTES: ".shopify-section > #tab-product-data"
};

export const HISTORY_MODES = {
    REPLACE: "replace",
    PUSH: "push"
};

export const HISTORY_MODE = HISTORY_MODES.REPLACE;

export const KEEP_SEARCH_PARAMS = true;
